// GET /billing/plans · POST /billing/interest
import { z } from 'zod'
import { idSchema } from './common.js'

/**
 * Коды тарифов. Живут в контракте, а не по обе стороны отдельно: фронт слал `year`, бэк ждал
 * `yearly`, и запись намерения падала с 422 — молча, потому что экран благодарности всё равно
 * открывался.
 */
export const billingPlanIdSchema = z.enum(['year', 'month'])
export type BillingPlanId = z.infer<typeof billingPlanIdSchema>

export const billingPlanDtoSchema = z.object({
  id: billingPlanIdSchema,
  title: z.string(),
  price: z.number().min(0),
  currency: z.string(),
  period_days: z.number().int().min(1),
  link_limit: z.number().int().min(0), // сколько уз открывает план (базовый лимит — 2)
})
export type BillingPlanDto = z.infer<typeof billingPlanDtoSchema>

// GET /billing/plans — «Миска».
export const listBillingPlansResponseSchema = z.object({
  items: z.array(billingPlanDtoSchema),
})
export type ListBillingPlansResponse = z.infer<typeof listBillingPlansResponseSchema>

/**
 * POST /billing/interest — «хочу подписку» до появления оплаты.
 *
 * На MVP платежей нет: ручка не запускает оплату, а записывает намерение (кто и откуда нажал),
 * чтобы на тестовом запуске посчитать конверсию. Платёжных данных не принимает и не хранит.
 */
export const subscriptionSourceSchema = z.enum(['paywall', 'bowl'])
export type SubscriptionSource = z.infer<typeof subscriptionSourceSchema>

export const createSubscriptionInterestRequestSchema = z.object({
  plan: billingPlanIdSchema.nullish(), // у «Миски» тарифа нет
  source: subscriptionSourceSchema,
})
export type CreateSubscriptionInterestRequest = z.infer<
  typeof createSubscriptionInterestRequestSchema
>
export const createSubscriptionInterestResponseSchema = z.object({ id: idSchema })
export type CreateSubscriptionInterestResponse = z.infer<
  typeof createSubscriptionInterestResponseSchema
>
